import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Shield, Loader2 } from "lucide-react";

export default function RBACRoles() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/rbac/roles")
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-court-orange" /></div>;
  if (!data) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-10 space-y-6" data-testid="rbac-roles-page">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight flex items-center gap-3"><Shield className="w-8 h-8 text-court-orange" />RBAC Roles</h1>
        <p className="text-muted-foreground mt-1">Back-office role templates, permission bundles, and route visibility matrix.</p>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        {Object.entries(data.roles || {}).map(([roleKey, role]) => (
          <Card key={roleKey} data-testid={`rbac-role-${roleKey}`}>
            <CardHeader><CardTitle className="font-heading text-lg">{role.label}</CardTitle></CardHeader>
            <CardContent className="space-y-3">
              <div className="flex flex-wrap gap-2">
                {(role.permissions || []).map((permission) => <Badge key={permission} variant="outline">{permission}</Badge>)}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}